import { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';
import React from 'react';
import { validationContext } from 'src/shared/validation';

interface ValidationMessageProps {
    validationKey: string;
    deferUntilSubmit?: boolean;
}

export const ValidationMessageStyled = styled.span`
    padding: 0;
    margin: 0;
    color: red;
    font-size: 11px;
    white-space: pre-wrap;
`;

const ValidationMessage: FunctionComponent<ValidationMessageProps> = (props) => {
    const _validationContext = useContext(validationContext);
    if (props.deferUntilSubmit && !_validationContext.hasSubmitted()) return null;

    const validation = _validationContext.validations?.find((v) => v.validationKey == props.validationKey);
    const hasError = !!(validation && validation.message);
    if (!hasError) return null;
    return <ValidationMessageStyled data-has-error>{validation.message}</ValidationMessageStyled>;
};

export default ValidationMessage;
